export default "__VITE_ASSET__ATun5W$H__"